import Layout from "@components/Layout"
import RadioInputButtonBlack from "@components/RadioInputButtonBlack"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function StatementTimePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  const name =
    t("pages.onboarding.statementTime.heading", { lng: "en" }) +
    " " +
    t("pages.onboarding.statementTime.text", { lng: "en" })

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboarding.statementTime.heading")}
        </h1>
      </div>

      <div className="flex grow flex-col justify-center text-center">
        <div className="space-y-4 bg-white p-8 shadow-xl">
          <span className="text-center text-3xl">😪</span>

          <p className="text-2xl italic">
            {t("pages.onboarding.statementTime.text")}
          </p>
        </div>
      </div>

      <Form
        className="inline-flex shrink-0 items-center justify-center gap-4"
        method="post"
      >
        <RadioInputButtonBlack
          label={t("pages.onboarding.statementTime.no")}
          name={name}
          onChange={handleChange}
          value={t("pages.onboarding.statementTime.no", { lng: "en" })}
        />

        <RadioInputButtonBlack
          label={t("pages.onboarding.statementTime.yes")}
          name={name}
          onChange={handleChange}
          value={t("pages.onboarding.statementTime.yes", { lng: "en" })}
        />
      </Form>
    </Layout>
  )
}
